import React, {useEffect} from 'react'
import { Col, Row } from 'antd'
import { connect } from 'react-redux'
import Layout from '../../components/Layout'
import actions from '../../redux/actions'
import Divider from '../../components/Divider'
import styled from 'styled-components'
import countryData from '../../assets/data/country.json';

const Text = styled.p`
  font-size: 18px;
  line-height: 24.3px;
`

const StyledCol = styled(Col)`
  margin: 1rem 0 !important;
`

const Country = (props) => {
  const handleClick = (id,value) => {
    props.setCountry(id,value)
    props.history.goBack()
  }

  useEffect(() => window.scrollTo(0,0));

  return (
    <Layout title={'ประเทศแหล่งที่มาของรายได้'} backIcon={true} onClick={() => props.history.goBack()}>
      <h4 style={{marginTop: '2rem', marginBottom: '1rem'}}>กรุณาเลือกประเทศแหล่งที่มาของรายได้</h4>
      <Row>
        {
          countryData.map(element =>
            <StyledCol key={element.id}>
              <Text onClick={() => handleClick(element.id,element.th)}>{element.th}</Text>
              <Divider floatRight={true}/>
            </StyledCol>
          )
        }
      </Row>
    </Layout>
  )
}

const mapDispatchToProps = {
  setCountry: actions.setCountry,
}

const CountryWithConnect = connect(null, mapDispatchToProps)(Country)

export default CountryWithConnect
